import { APIService } from "services";

export const getStep_Tariffs = async (pageNo, pageSize, search) => {
  let res;
  if (search.length === 0) {
    res = await getAllStep_Tariffs(pageNo, pageSize);
  } else {
    try {
      res = await searchStep_Tariffs(search, pageNo, pageSize);
    } catch (err) {
      return { records: [], totalCount: 0 };
    }
  }
  if (res && res.data) {
    return res.data;
  } else {
    return { records: [], totalCount: 0 };
  }
};

export const addStep_Tariffs = (data) => {
  return APIService.api().post(`/step_tariffs`, data);
};
export const updateStep_Tariffs = (id, data) => {
  return APIService.api().patch(`/step_tariffs/${id}`, data);
};
export const getAllStep_Tariffs = (pageNo, pageSize) => {
  return APIService.api().get(
    `/step_tariffs/?pageNo=${pageNo}&pageSize=${pageSize}`
  );
};
export const getOneStep_Tariffs = (id) => {
  return APIService.api().get(`/step_tariffs/${id}`);
};
export const searchStep_Tariffs = (searchKey, pageNo, pageSize) => {
  return APIService.api().get(
    `/step_tariffs/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`
  );
};
export const deleteStep_Tariffs = (id) => {
  return APIService.api().delete(`/step_tariffs/${id}`);
};
